






















import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import { GetZhenciDetail } from "@/request/common";
@Component({})
export default class Name extends Vue {
  @Prop()
  private data: any;
  @Watch("data", { immediate: true })
  private dataChange() {
    if (!this.cZhenci["名称"]) {
      this.cZhenci = this.data["诊次"][0];
      this.getDetail();
    }
  }
  private cZhenci: any = {};
  private detail: any = {};
  private keys: any = [
    {
      label: "主诉",
      value: "主诉",
    },
    {
      label: "现病史",
      value: "现病史",
    },
    {
      label: "既往史",
      value: "既往史",
    },
    {
      label: "个人史",
      value: "个人史",
    },
    {
      label: "家族史",
      value: "家族史",
    },
    {
      label: "月经史及生育史",
      value: "月经史及生育史",
    },
    {
      label: "舌",
      value: "舌",
    },
    {
      label: "面",
      value: "面",
    },
    {
      label: "声息气味",
      value: "声息气味",
    },
    {
      label: "脉诊",
      value: "脉诊",
    },
    {
      label: "中医辨证",
      value: "中医辨证",
    },
    {
      label: "中医辨病",
      value: "中医辨病",
    },
    {
      label: "治则治法",
      value: "治则治法",
    },
    {
      label: "中药饮片信息",
      value: "中药饮片信息",
    },
  ];
  private changeZhenci(item: any) {
    this.cZhenci = item;
    this.getDetail();
  }
  private getDetail() {
    const params: any = {
      params: {
        menzhen_id: this.cZhenci.menzhen_id,
      },
    };
    const loading = this.$loading({
      lock: true,
      text: "加载中……",
      spinner: "el-icon-loading",
      customClass: "loadClass",
      background: "rgba(255, 255, 255, 0.7)",
    });
    GetZhenciDetail(this, params, loading)
      .then((res: any) => {
        loading.close();
        this.detail = res;
      })
      .catch(() => {
        loading.close();
      });
  }
  private mounted() {}
}
